import React, { useMemo, } from 'react';
import { connect, } from 'react-redux';
import { ShopCartItem, } from 'store/ducks/shopCart/types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { flatProducts, renderRows, } from './selectors';
import { FlattenProducts, Headers, } from './types';
import { formatPrice, } from 'common/functions';
import { PRODUCTS_PRODUCT_ITEM_MAP } from 'api/repositories/Products/Products';

const headers = [
    {
        label: 'lp.',
        props: {
            padding: 'checkbox',
        },
    },
    {
        label: 'Nazwa',
    },
    {
        label: 'Sztuk',
        props: {
            align: 'right',
        },
    },
    {
        label: 'Stawka VAT',
        props: {
            align: 'right',
        },
    },
    {
        label: 'Suma brutto',
        props: {
            align: 'right',
        },
    },
];

const renderHeaders = ({ label, props, }: Headers) => (
    <TableCell key={label} {...props}>
        {label}
    </TableCell>
);

const renderProducts = (prevProduct: FlattenProducts | null, current: FlattenProducts, productsQuantity: number) => {
    const noIsNotEqual = prevProduct?.no !== current.no;
    const isSet = current.type === PRODUCTS_PRODUCT_ITEM_MAP.GRANT_SET || current.products;
    const calculatedPrice = isSet ? '' : current.price && current.quantity && formatPrice(current.price * current.quantity);
    const showNo = current.products || noIsNotEqual;
    const tax = (current.taxAmount ?? 0) * 100;

    return (
        <TableRow key={current.code}>
            {showNo && <TableCell padding="checkbox" rowSpan={productsQuantity}>{current.no}</TableCell>}
            <TableCell component="th" scope="row">
                {current.name}
            </TableCell>
            <TableCell align="right">{!isSet && current.quantity}</TableCell>
            <TableCell align="right">{!isSet && tax + '%'}</TableCell>
            <TableCell align="right">{calculatedPrice}</TableCell>
        </TableRow>
    );
};

type Props = {
    shopCart: Array<ShopCartItem>,
};

const SummaryOrderTable: React.FC<Props> = ({ shopCart, }) => {
    const prepareProducts = useMemo(
        () => shopCart.reduce(flatProducts, []),
        [ shopCart, ]
    ) || [];

    const renderedRows = useMemo(
        () => renderRows(prepareProducts, renderProducts),
        [ prepareProducts, ]
    );

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {headers.map(renderHeaders)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderedRows}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

type MappingType = {
    shopCart: Array<ShopCartItem>,
};

const mapStateToProps = ({ shopCart, }: MappingType) => ({ shopCart, });

export default connect(
    mapStateToProps,
)(SummaryOrderTable);
